module.exports = __webpack_public_path__ + "static/media/oberflex-frenefr112-2560x1440.1b2a99c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frenefr112-2560x1440.jpg
// module id = 1023
// module chunks = 37